import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService, LoaderState } from '../../services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  loaderState: LoaderState = { loading: false, showGenericSpinner: false, loadingMessageKey: '' };


  constructor(private loader: LoaderService) { }

  ngOnInit(): void {
    this.subscription = this.loader.getLoading().subscribe((state) => {
      this.loaderState = state;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
